import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden"]
  static values = { items: Array }

  connect() {
    const items = this.itemsValue
    const hiddenTarget = this.hiddenTarget
    const inputTarget = this.inputTarget

    $(inputTarget).autocomplete({
      source: items.map(item => ({ label: item.name, value: item.name, id: item.id })),
      minLength: 0,
      select: function(_event, ui) {
        hiddenTarget.value = ui.item.id
      },
      change: function(_event, ui) {
        if (!ui.item) {
          inputTarget.value = ""
          hiddenTarget.value = ""
        }
      }
    })

    $(inputTarget).on("focus", function() {
      $(this).autocomplete("search", $(this).val())
    })
  }
}
